function prodInitReveal() {
  const els = document.querySelectorAll('.prod-reveal:not(.prod-visible)');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('prod-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('prod-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => io.observe(el));
}

function prodInitGaleriaProducto() {
  const galerias = document.querySelectorAll('[data-prod-galeria]');
  galerias.forEach((galeria) => {
    const principal = galeria.querySelector('[data-prod-imagen-principal]');
    const minis = galeria.querySelectorAll('[data-prod-mini]');
    if (!principal || !minis.length) return;
    minis.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.dataset.prodMini;
        principal.src = src;
        minis.forEach((m) => m.classList.remove('prod-mini-activa'));
        mini.classList.add('prod-mini-activa');
      });
    });
  });
}

function prodInitVariantes() {
  const forms = document.querySelectorAll('.prod-producto-form');
  forms.forEach((form) => {
    const selects = form.querySelectorAll('[data-prod-opcion]');
    const idInput = form.querySelector('input[name="id"]');
    const precioEl = form.querySelector('[data-prod-precio]');
    const compareEl = form.querySelector('[data-prod-precio-comparado]');
    const botonEl = form.querySelector('[data-prod-boton-comprar]');
    const dataEl = form.querySelector('[data-prod-variantes-json]');
    if (!selects.length || !idInput || !dataEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    function actualizar() {
      const valores = Array.from(selects).map((s) => s.value);
      const variante = variantes.find((v) => v.options.every((opt, i) => opt === valores[i]));
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = variante.precioFormateado;
      if (compareEl) {
        if (variante.compareFormateado) {
          compareEl.textContent = variante.compareFormateado;
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (botonEl) {
        if (variante.disponible) {
          botonEl.disabled = false;
          botonEl.textContent = botonEl.dataset.textoDisponible;
        } else {
          botonEl.disabled = true;
          botonEl.textContent = botonEl.dataset.textoAgotado;
        }
      }
    }
    selects.forEach((s) => s.addEventListener('change', actualizar));
    actualizar();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  prodInitReveal();
  prodInitGaleriaProducto();
  prodInitVariantes();
});
